import { useWhatsApp } from '@bluheadless/ui-logic/src/hooks/whatsapp/useWhatsApp'
import WhatsappIcon from '../../atoms/icons/social/whatsapp-icon'
import FloatingAction from '../../molecules/floating-action'

const WhatsappButton = ({ ...props }) => {
	const waLink = useWhatsApp()

	return waLink ? <FloatingAction href={waLink} Icon={WhatsappIcon} {...props} /> : null
}

WhatsappButton.defaultProps = {
	textColor: '#FFFFFF',
	backgroundColor: '#46c757',
}

WhatsappButton.propTypes = {
	...FloatingAction.propTypes,
}

export default WhatsappButton
